<div *ngIf="_selectedFilters.length > 0" class="filters-selected-groups">

    <div *ngFor="let item of _selectedFilters" class="filters-selected-groups--item font-5 font-weight-bold">
        <span [innerHTML]="item.label | safeContent"></span><button class="clear-selection btn btn-icon font-6 color-white" (click)="remove(item)"><i class="fas fa-times"></i></button>
    </div>
    <div *ngIf="showClearAllButton">
        <button class="btn btn-link" (click)="clearAll()">Clear All</button>
    </div>
</div>
